// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1VTRU","buttons":"Footer_buttons__MxK2c"};